import { render, staticRenderFns } from "./PORTFOLIOREPOST.vue?vue&type=template&id=88772b82"
import script from "./PORTFOLIOREPOST.vue?vue&type=script&lang=js"
export * from "./PORTFOLIOREPOST.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports